import { BorderSize } from "../../../../base/styles";
import clsx from "clsx";

export const SelectBorderSize = ({ title, value, className, onChange }:{
    title: string,
    value?: BorderSize,
    className?: string,
    onChange: (value?: BorderSize) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as BorderSize;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={BorderSize.Border0}>0</option>
                <option value={BorderSize.Border1}>1</option>
                <option value={BorderSize.Border2}>2</option>
                <option value={BorderSize.Border3}>3</option>
                <option value={BorderSize.Border4}>4</option>
                <option value={BorderSize.Border5}>5</option>
            </select>
        </div>
    )
}